import { useState, useEffect } from 'react'
import { configService } from '@/modules/config/services/configService'
import type { Config } from '@/modules/config/types'

/**
 * Loads company configuration.
 * Used by points pages to know exchange rates, products, min points, etc.
 */
export function useConfig() {
  const [config, setConfig] = useState<Config | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const data = await configService.get()
        setConfig(data)
      } catch {
        // Config load failure is non-fatal for points pages
      } finally {
        setIsLoading(false)
      }
    }
    fetchConfig()
  }, [])

  return { config, isLoading }
}
